import { Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { of, from } from 'rxjs';
import { debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { ReservaDoctorService } from 'src/app/services/reserva-doctor.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { GeneralService } from 'src/app/services/general.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { YappService } from 'src/app/services/yapp.service';
import { FichaMedicaService } from 'src/app/services/ficha-medica.service';
import { URL_DOCS } from 'src/app/config/config';

interface YappSelectedItem {
  clinicalIds: number[];
  commercialIds: number[];
  title: string;
  subtitle: string;
  indication: string;
}

@Component({
  selector: 'app-receta-form',
  templateUrl: './receta-form.component.html',
  styleUrls: ['./receta-form.component.css']
})
export class RecetaFormComponent implements OnInit {

  _title = 'Documentos > Talonario digital';
  _subtitle = 'Receta médica';

  usuario: any = {};
  pageInfo: any = {};

  currentStep = 0;

  steps = {
    searchPatient: true,
    prescriptionData: false,
    prescriptionFirma: false,
    prescriptionSummary: false
  };

  uiSteps = [
    { title: 'Datos del paciente', icon: 'fi fi-rr-user' },
    { title: 'Receta e indicaciones', icon: 'fi fi-rr-prescription-bottle' },
    { title: 'Firma y generación', icon: 'fi fi-rr-file-signature' },
    { title: 'Resumen del documento', icon: 'fi fi-rr-document-signed' }
  ];

  searchCtrl = new FormControl('');

  resultados: any[] = [];
  loading = false;
  showDropdown = false;
  minSearchLen = 4;
  tooShort = false;
  searchRutInvalid = false;

  infoRut: any = {};
  isNewUser = false;
  step1Unlocked = false;

  areaCodes: any[] = [];

  selectedAreaCode: any = {
    cou_phone_code: '56',
    cou_flag: 'fi-cl',
    cou_min_phone: 9,
    cou_max_phone: 9
  };

  flagDropdownOpen = false;

  paises: any[] = [];
  regiones: any[] = [];
  comunas: any[] = [];

  loadingPaises = false;
  loadingRegiones = false;
  loadingComunas = false;

  recetas: any = null;
  recetasFiltradas: any[] = [];

  /**
   * Tipos que permiten YAPP:
   * 1 = SIMPLE
   * 2 = RETENIDA ESTUPEFACIENTES 1
   * 3 = RETENIDA ESTUPEFACIENTES 2
   * 4 = MAGISTRAL => NO muestra YAPP
   */
  private readonly YAPP_PRESCRIPTION_TYPE_IDS = [1, 2, 3];

  selectedRegionId: number | null = null;
  selectedComunaId: number | null = null;

  selectedRegionObj: any = null;
  selectedComunaObj: any = null;

  regionesYapp: any[] = [];
  comunasYapp: any[] = [];

  yappCommune = 13101;
  yappQuery = '';
  yappResults: any[] = [];
  yappSelectedItems: YappSelectedItem[] = [];

  yappLoading = false;
  yappShowDropdown = false;

  URL_DOCS = URL_DOCS;

  loadingCrearReceta = false;
  respuestaCrearReceta: any = null;
  errorCrearReceta = '';
  payloadRecetaGenerada: any = null;

  documentoGeneradoUrl = '';
  safeDocumentoGeneradoUrl: SafeResourceUrl | null = null;
  attIdDocumentoGenerado: any = null;

  resendEmailCtrl = new FormControl('', [Validators.required, Validators.email]);
  loadingReenvio = false;
  mensajeReenvio = '';
  errorReenvio = '';

  private yappDebounceTimer: any = null;
  private yappReqId = 0;

  patientForm: FormGroup;
  prescriptionForm: FormGroup;

  private step1EditableControls = [
    'use_name',
    'paterno',
    'materno',
    'nacimiento',
    'telefonoCodigo',
    'telefono',
    'email',
    'use_address_cou_id',
    'use_address_reg_id',
    'use_address_com_id',
    'use_address_street',
    'use_address_number',
    'use_address_rest'
  ];

  constructor(
    private fb: FormBuilder,
    public reservaDoctor: ReservaDoctorService,
    private usuarioService: UsuarioService,
    private generalService: GeneralService,
    private encriptacionService: EncriptacionService,
    private _yappService: YappService,
    private _fichaMedicaServices: FichaMedicaService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    this.patientForm = this.fb.group({
      use_id: [''],

use_rut: [
  '',
  [
    Validators.required,
    Validators.pattern(/^[0-9]{1,8}-?[0-9Kk]$/)
  ]
],      use_name: ['', [Validators.required]],

      paterno: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.pattern("^[a-zA-ZáéíóúÁÉÍÓÚñÑçÇ' ]+$")
        ]
      ],

      materno: [
        '',
        [
          Validators.minLength(3),
          Validators.pattern("^[a-zA-ZáéíóúÁÉÍÓÚñÑçÇ' ]+$")
        ]
      ],

      nacimiento: ['', Validators.required],

      telefonoCodigo: ['56', [Validators.required]],

      telefono: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]*$')
        ]
      ],

      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.minLength(3)
        ]
      ],

      use_address_cou_id: [null, Validators.required],
      use_address_reg_id: [null, Validators.required],
      use_address_com_id: [null, Validators.required],
      use_address_street: ['', Validators.required],
      use_address_number: ['', Validators.required],
      use_address_rest: ['']
    });

    this.prescriptionForm = this.fb.group({
      id_receta: ['', Validators.required],
      prescriptionText: [''],
      check_firma: [false],
      signatureType: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.usuario = this.encriptacionService.getUserInfo();
    this.pageInfo = this.encriptacionService.getPageInfo();
    // console.log(this.pageInfo);

    this.getCodPaises();
    this.getPaises();
    this.getListarPrescriptionType();
    this.initAutocomplete();
    this.lockStep1Form();

    this.patientForm.get('use_address_cou_id')?.valueChanges.subscribe((couId: any) => {
      if (couId) {
        this.onPaisChange(Number(couId));
      }
    });

    this.patientForm.get('use_address_reg_id')?.valueChanges.subscribe((regId: any) => {
      if (regId) {
        this.onRegionChange(Number(regId));
      }
    });
  }

  get patientData(): any {
    return this.patientForm.getRawValue();
  }

  get prescriptionData(): any {
    return this.prescriptionForm.getRawValue();
  }

  get signatureType(): string {
    return this.prescriptionForm.get('signatureType')?.value;
  }

  get doctorTieneFirmaAvanzada(): boolean {
    return this.usuario?.doc_enrolled === true;
  }

  goStep1(): void {
    this.currentStep = 0;

    this.steps = {
      searchPatient: true,
      prescriptionData: false,
      prescriptionFirma: false,
      prescriptionSummary: false
    };
  }

  goStep2(): void {
    this.currentStep = 1;

    this.steps = {
      searchPatient: false,
      prescriptionData: true,
      prescriptionFirma: false,
      prescriptionSummary: false
    };
  }

  goStep3(): void {
    this.currentStep = 2;

    this.steps = {
      searchPatient: false,
      prescriptionData: false,
      prescriptionFirma: true,
      prescriptionSummary: false
    };
  }

  nextFromStep1(): void {
    if (!this.isStep1Valid()) {
      this.patientForm.markAllAsTouched();
      return;
    }

    this.goStep2();
  }

  nextFromStep2(): void {
    const textoFinal = this.buildPrescriptionText();

    if (!this.prescriptionForm.get('id_receta')?.value || !textoFinal.trim()) {
      this.prescriptionForm.markAllAsTouched();
      return;
    }

    this.goStep3();
  }

  volverStep1(): void {
    this.goStep1();
  }

  volverStep2(): void {
    this.goStep2();
  }

  goStep4(): void {
    this.currentStep = 3;

    this.steps = {
      searchPatient: false,
      prescriptionData: false,
      prescriptionFirma: false,
      prescriptionSummary: true
    };
  }

  async nextFromStep3(): Promise<void> {
  if (!this.isStep3Valid()) {
    this.prescriptionForm.get('signatureType')?.markAsTouched();
    return;
  }

  if (this.loadingCrearReceta) {
    return;
  }

  this.loadingCrearReceta = true;
  this.errorCrearReceta = '';
  this.respuestaCrearReceta = null;
  this.documentoGeneradoUrl = '';
  this.safeDocumentoGeneradoUrl = null;
  this.mensajeReenvio = '';
  this.errorReenvio = '';
  this.attIdDocumentoGenerado = null;

  Swal.fire({
    allowOutsideClick: false,
    allowEscapeKey: false,
    html: `
      <div style="margin: 40px 0;">
        <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
        <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #2BABB7;">
          Generando documento
        </h1>
      </div>
    `,
    showConfirmButton: false
  });

  const payload = this.buildPayloadRecetaTalonarioDigital();

  this.payloadRecetaGenerada = JSON.parse(JSON.stringify(payload));

  // console.log('[RECETA TALONARIO DIGITAL] Payload a enviar:', payload);

  try {
    const response: any = await this._fichaMedicaServices.postCrearRecetaTalonarioDigital(payload);

    // console.log('[RECETA TALONARIO DIGITAL] Respuesta servicio:', response);

    if (!response || response.status !== true) {
      this.errorCrearReceta = response?.mensaje || 'No fue posible generar la receta médica.';

      Swal.fire({
        icon: 'error',
        title: 'No fue posible generar la receta',
        text: this.errorCrearReceta,
        confirmButtonColor: '#2BABB7'
      });

      return;
    }

    this.respuestaCrearReceta = response;
    this.attIdDocumentoGenerado = this.getAttIdFromResponse(response);

    // console.log('[RECETA TALONARIO DIGITAL] att_id documento generado:', this.attIdDocumentoGenerado);

    this.prepararDocumentoGenerado(response);

    this.currentStep = 3;
    this.steps = {
      searchPatient: false,
      prescriptionData: false,
      prescriptionFirma: false,
      prescriptionSummary: true
    };

    Swal.close();

  } catch (error) {
    console.error('[RECETA TALONARIO DIGITAL] Error al crear receta:', error);

    this.errorCrearReceta = 'No fue posible generar la receta médica. Intente nuevamente.';

    Swal.fire({
      icon: 'error',
      title: 'Error al generar la receta',
      text: this.errorCrearReceta,
      confirmButtonColor: '#2BABB7'
    });

  } finally {
    this.loadingCrearReceta = false;

    if (Swal.isVisible()) {
      Swal.close();
    }
  }
}

  volverStep3(): void {
    this.goStep3();
  }

  setSignatureType(type: 'simple' | 'advanced'): void {
    if (type === 'advanced' && !this.doctorTieneFirmaAvanzada) {
      console.warn('[RECETA TALONARIO DIGITAL] El médico no tiene firma avanzada enrolada.');
      return;
    }

    this.prescriptionForm.patchValue({
      signatureType: type,
      check_firma: type === 'advanced'
    });

    // console.log('[RECETA TALONARIO DIGITAL] Tipo de firma seleccionada:', type);
    // console.log('[RECETA TALONARIO DIGITAL] is_fea:', type === 'advanced');
  }

  getSignatureName(): string {
    if (this.signatureType === 'simple') {
      return 'Firma Electrónica Simple';
    }

    if (this.signatureType === 'advanced') {
      return 'Firma Electrónica Avanzada';
    }

    return '—';
  }

  isStep1Valid(): boolean {
  return this.patientForm.valid && this.step1Unlocked && !this.searchRutInvalid;
}

  isStep2Valid(): boolean {
    const textoFinal = this.buildPrescriptionText();

    return !!this.prescriptionForm.get('id_receta')?.value && !!textoFinal.trim();
  }

  isStep3Valid(): boolean {
    return !!this.prescriptionForm.get('signatureType')?.valid;
  }

  getListarPrescriptionType(): void {
    this._fichaMedicaServices.getListarPrescriptionType()
      .then((results: any) => {
        this.recetas = results;

        const todas = this.recetas?.recetas || [];

        if (this.usuario?.doc_enrolled) {
          this.recetasFiltradas = todas;
        } else {
          this.recetasFiltradas = todas.filter((r: any) => {
            const id = Number(r.pre_typ_id);
            return id !== 2 && id !== 3;
          });
        }
      })
      .catch((error: any) => {
        console.error('Error al listar tipos de receta:', error);
        this.recetas = null;
        this.recetasFiltradas = [];
      });
  }

  getCodPaises(): void {
    this.usuarioService.getCodPaises()
      .then((resp: any) => {
        this.areaCodes = this.normalizeList(resp);

        const chile = this.areaCodes.find((c: any) => String(c.cou_phone_code) === '56');

        if (chile) {
          this.selectedAreaCode = chile;

          this.patientForm.patchValue({
            telefonoCodigo: chile.cou_phone_code
          }, { emitEvent: false });

          this.setTelefonoValidators(chile);
        }
      })
      .catch(() => {
        this.areaCodes = [];
      });
  }

  getPaises(): void {
    this.loadingPaises = true;

    this.usuarioService.getPaises()
      .then((resp: any) => {
        this.paises = this.normalizeList(resp);

        const chile = this.paises.find((p: any) =>
          String(p.cou_id) === '1' ||
          String(p.cou_name || '').toLowerCase().includes('chile')
        );

        if (chile && !this.patientForm.get('use_address_cou_id')?.value) {
          this.patientForm.patchValue({
            use_address_cou_id: chile.cou_id
          }, { emitEvent: true });
        }
      })
      .catch((error: any) => {
        console.error('Error al obtener países:', error);
        this.paises = [];
      })
      .finally(() => {
        this.loadingPaises = false;
      });
  }

  onPaisChange(couId: number, limpiarSeleccion = true): void {
    if (!couId) {
      this.regiones = [];
      this.comunas = [];
      return;
    }

    if (limpiarSeleccion) {
      this.patientForm.patchValue({
        use_address_reg_id: null,
        use_address_com_id: null
      }, { emitEvent: false });
    }

    this.loadingRegiones = true;

    this.usuarioService.getRegiones(couId)
      .then((resp: any) => {
        this.regiones = this.normalizeList(resp);
      })
      .catch((error: any) => {
        console.error('Error al obtener regiones:', error);
        this.regiones = [];
      })
      .finally(() => {
        this.loadingRegiones = false;
      });
  }

  onRegionChange(regId: number, limpiarSeleccion = true): void {
    if (!regId) {
      this.comunas = [];
      return;
    }

    if (limpiarSeleccion) {
      this.patientForm.patchValue({
        use_address_com_id: null
      }, { emitEvent: false });
    }

    this.loadingComunas = true;

    this.usuarioService.getComunas(regId)
      .then((resp: any) => {
        this.comunas = this.normalizeList(resp);
      })
      .catch((error: any) => {
        console.error('Error al obtener comunas:', error);
        this.comunas = [];
      })
      .finally(() => {
        this.loadingComunas = false;
      });
  }

 private initAutocomplete(): void {
  this.searchCtrl.valueChanges.pipe(
    debounceTime(250),

    tap((v: any) => {
      const term = (v || '').toString().trim();

      if (!term) {
        this.clearPatientForm();
        this.showDropdown = false;
        this.tooShort = false;
        this.searchRutInvalid = false;
        this.resultados = [];
        this.infoRut = {};
        this.isNewUser = false;
        this.lockStep1Form();
        return;
      }

      this.showDropdown = true;
      this.tooShort = term.length < this.minSearchLen;
      this.loading = !this.tooShort;
    }),

    switchMap((v: string) => {
      const term = (v || '').toString().trim();

      if (!term || term.length < this.minSearchLen) {
        this.loading = false;
        return of([]);
      }

      return from(
        this.reservaDoctor.getVerificarPacienteAgenda({ rut: term })
      ).pipe(
        catchError(() => of([]))
      );
    })
  ).subscribe((resp: any) => {
    this.loading = false;

    this.resultados = Array.isArray(resp)
      ? resp
      : (resp ? [resp] : []);

    if (this.resultados.length > 0 && !this.isNewUser) {
      this.lockStep1Form();
    }
  });
}

  onRutSearchInput(raw: string): void {
  const clean = this.normalizeRutDigits(raw);
  const formatted = this.formatRutWithDash(clean);

  this.searchCtrl.setValue(formatted, { emitEvent: true });

  // No se valida mientras escribe para permitir coincidencias parciales.
  // La validación real se hace al presionar "Agregar usuario".
  this.searchRutInvalid = false;
}

  onEnterSearch(): void {
  let rut = (this.searchCtrl.value || '').toString().trim();

  rut = this.formatRutWithDash(rut);
  this.searchCtrl.setValue(rut, { emitEvent: false });

  if (!rut || rut.length < this.minSearchLen) {
    this.showDropdown = !!rut;
    this.tooShort = !!rut;
    this.resultados = [];
    return;
  }

  this.loading = true;
  this.showDropdown = true;
  this.searchRutInvalid = false;

  this.reservaDoctor.getVerificarPacienteAgenda({ rut })
    .then((resp: any) => {
      this.resultados = Array.isArray(resp)
        ? resp
        : (resp ? [resp] : []);
    })
    .catch(() => {
      this.resultados = [];
    })
    .finally(() => {
      this.loading = false;
    });
}

  normalizarRutComparacion(value: any): string {
  return (value || '')
    .toString()
    .replace(/\./g, '')
    .replace(/-/g, '')
    .toUpperCase()
    .replace(/[^0-9K]/g, '');
}

rutYaExisteExacto(): boolean {
  const rutBuscado = this.normalizarRutComparacion(this.searchCtrl.value);

  if (!rutBuscado) {
    return false;
  }

  return this.resultados.some((p: any) => {
    const rutPaciente = this.normalizarRutComparacion(p?.use_rut || p?.use_username);
    return rutPaciente === rutBuscado;
  });
}

puedeMostrarAgregarRutBuscado(): boolean {
  const typed = (this.searchCtrl.value || '').toString().trim();

  if (!typed || typed.length < this.minSearchLen) {
    return false;
  }

  return !this.rutYaExisteExacto();
}

  seleccionarUsuario(item: any): void {
  const areaCode = this.areaCodes.find(
    (a: any) => String(a.cou_phone_code) === String(item?.use_cod_area)
  );

  if (areaCode) {
    this.selectedAreaCode = areaCode;
    this.setTelefonoValidators(areaCode);
  }

  this.isNewUser = false;
  this.searchRutInvalid = false;

  const raw = this.formatRutWithDash(item?.use_rut || item?.use_username || '');

  this.searchCtrl.setValue(raw, { emitEvent: false });

  this.infoRut = item;
  this.showDropdown = false;

  const countryId = item?.use_address_cou_id || item?.use_cou_id || 1;
  const regionId = item?.use_address_reg_id || null;
  const comunaId = item?.use_address_com_id || null;

  this.patientForm.patchValue({
    use_id: item?.use_id || '',
    use_rut: raw,
    use_name: item?.use_name || '',
    paterno: item?.use_paternal_surname || '',
    materno: item?.use_maternal_surname || '',
    nacimiento: this.toDateInput(item?.use_birthdate),
    email: item?.use_email || '',
    telefono: item?.use_movil_phone || item?.use_phone || '',
    telefonoCodigo: this.normArea(item?.use_cod_area) || '56',

    use_address_cou_id: countryId,
    use_address_reg_id: regionId,
    use_address_com_id: comunaId,
    use_address_street: item?.use_address_street || '',
    use_address_number: item?.use_address_number || '',
    use_address_rest: item?.use_address_rest || ''
  }, { emitEvent: false });

  this.unlockStep1Form();
  this.patientForm.updateValueAndValidity();

  if (countryId) {
    this.onPaisChange(Number(countryId), false);
  }

  if (regionId) {
    this.onRegionChange(Number(regionId), false);
  }
}


  
  prepararNuevoUsuario(): void {
  const typed = (this.searchCtrl.value || '').toString().trim();

  if (!typed) {
    this.lockStep1Form();
    return;
  }

  if (this.rutYaExisteExacto()) {
    this.searchRutInvalid = false;
    this.lockStep1Form();
    return;
  }

  const rutValido = this.generalService.validaRutChileno(typed);

  if (!rutValido) {
    this.searchRutInvalid = true;
    this.showDropdown = true;
    this.isNewUser = false;
    this.clearPatientForm();
    this.lockStep1Form();
    return;
  }

  this.searchRutInvalid = false;
  this.isNewUser = true;
  this.showDropdown = false;
  this.resultados = [];

  const defaultCountry = this.getDefaultCountryId();

  this.patientForm.reset({
    use_id: '',
    use_rut: typed,
    use_name: '',
    paterno: '',
    materno: '',
    nacimiento: '',
    telefonoCodigo: this.selectedAreaCode?.cou_phone_code || '56',
    telefono: '',
    email: '',
    use_address_cou_id: defaultCountry,
    use_address_reg_id: null,
    use_address_com_id: null,
    use_address_street: '',
    use_address_number: '',
    use_address_rest: ''
  });

  this.unlockStep1Form();
  this.patientForm.updateValueAndValidity();

  if (defaultCountry) {
    this.onPaisChange(Number(defaultCountry), true);
  }
}

  lockStep1Form(): void {
    this.step1Unlocked = false;

    this.step1EditableControls.forEach(control => {
      this.patientForm.get(control)?.disable({ emitEvent: false });
    });
  }

  unlockStep1Form(): void {
    this.step1Unlocked = true;

    this.step1EditableControls.forEach(control => {
      this.patientForm.get(control)?.enable({ emitEvent: false });
    });
  }

  clearPatientForm(): void {
    const defaultCountry = this.getDefaultCountryId();

    this.patientForm.reset({
      use_id: '',
      use_rut: '',
      use_name: '',
      paterno: '',
      materno: '',
      nacimiento: '',
      telefonoCodigo: this.selectedAreaCode?.cou_phone_code || '56',
      telefono: '',
      email: '',

      use_address_cou_id: defaultCountry,
      use_address_reg_id: null,
      use_address_com_id: null,
      use_address_street: '',
      use_address_number: '',
      use_address_rest: ''
    });

    this.regiones = [];
    this.comunas = [];
  }

  onAreaCodeDropdownClick(event: MouseEvent): void {
    event.stopPropagation();

    if (!this.step1Unlocked) {
      return;
    }

    this.toggleFlagDropdown();
  }

  toggleFlagDropdown(): void {
    this.flagDropdownOpen = !this.flagDropdownOpen;
  }

  selectAreaCode(areaCode: any): void {
    this.selectedAreaCode = areaCode;
    this.flagDropdownOpen = false;

    this.patientForm.patchValue({
      telefonoCodigo: areaCode.cou_phone_code
    });

    this.setTelefonoValidators(areaCode);
  }

  setTelefonoValidators(areaCode: any): void {
    const telCtrl = this.patientForm.get('telefono');

    telCtrl?.setValidators([
      Validators.required,
      Validators.pattern('^[0-9]*$'),
      Validators.minLength(areaCode.cou_min_phone),
      Validators.maxLength(areaCode.cou_max_phone)
    ]);

    telCtrl?.updateValueAndValidity();
  }

  onChangeTipoReceta(value: any): void {
    this.prescriptionForm.patchValue({
      id_receta: value
    });

    if (this.mostrarBuscadorYapp()) {
      this.initRegionComunaYapp();
    } else {
      this.resetYappState();
    }
  }

  mostrarBuscadorYapp(): boolean {
    const idReceta = Number(this.prescriptionForm.get('id_receta')?.value);

    const customerCanYapp =
      this.pageInfo?.cus_can_yapp === true ||
      this.pageInfo?.cus_can_yapp === 'true' ||
      this.pageInfo?.cus_can_yapp === 1 ||
      this.pageInfo?.cus_can_yapp === '1';

    return customerCanYapp && this.YAPP_PRESCRIPTION_TYPE_IDS.includes(idReceta);
  }

  private async initRegionComunaYapp(): Promise<void> {
    try {
      const patient = this.patientForm.getRawValue();

      const couId = Number(patient?.use_address_cou_id || this.usuario?.cou_id || 1);

      await this.cargarRegionesYapp(couId);

      const regId = Number(patient?.use_address_reg_id || 0);
      const comId = Number(patient?.use_address_com_id || 0);

      if (regId) {
        this.selectedRegionId = regId;

        this.selectedRegionObj = this.regionesYapp.find((r: any) =>
          Number(r.reg_id) === Number(regId)
        ) || null;

        await this.cargarComunasYapp(regId);

        if (comId) {
          this.selectedComunaId = comId;

          this.selectedComunaObj = this.comunasYapp.find((c: any) =>
            Number(c.com_id) === Number(comId)
          ) || null;
        }
      }

      this.yappCommune = this.resolveCommune();

    } catch (error) {
      console.error('Error inicializando región/comuna YAPP:', error);
    }
  }

  private async cargarRegionesYapp(couId: number): Promise<void> {
    try {
      const resp = await this.usuarioService.getRegiones(couId);
      this.regionesYapp = this.normalizeList(resp);
    } catch (error) {
      console.error('Error al cargar regiones YAPP:', error);
      this.regionesYapp = [];
    }
  }

  private async cargarComunasYapp(regId: number): Promise<void> {
    try {
      const resp = await this.usuarioService.getComunas(regId);
      this.comunasYapp = this.normalizeList(resp);
    } catch (error) {
      console.error('Error al cargar comunas YAPP:', error);
      this.comunasYapp = [];
    }
  }

  async onRegionYappChange(regionId: any): Promise<void> {
    this.selectedRegionId = regionId != null ? Number(regionId) : null;

    this.selectedRegionObj = this.regionesYapp.find((r: any) =>
      Number(r.reg_id) === Number(this.selectedRegionId)
    ) || null;

    this.selectedComunaId = null;
    this.selectedComunaObj = null;
    this.comunasYapp = [];

    if (this.selectedRegionId) {
      await this.cargarComunasYapp(this.selectedRegionId);
    }

    this.yappCommune = this.resolveCommune();
  }

  onComunaYappChange(comunaId: any): void {
    this.selectedComunaId = comunaId != null ? Number(comunaId) : null;

    this.selectedComunaObj = this.comunasYapp.find((c: any) =>
      Number(c.com_id) === Number(this.selectedComunaId)
    ) || null;

    this.yappCommune = this.resolveCommune();
  }

  private getUbicacionYappFinal(): {
    reg_id: number | null;
    reg_name: string | null;
    com_id: number | null;
    com_name: string | null;
    code_yapp: number | null;
  } {
    const patient = this.patientForm.getRawValue();

    const regionSeleccionada =
      this.selectedRegionObj ||
      this.regionesYapp.find((r: any) => Number(r.reg_id) === Number(this.selectedRegionId)) ||
      this.regiones.find((r: any) => Number(r.reg_id) === Number(patient.use_address_reg_id)) ||
      null;

    const comunaSeleccionada =
      this.selectedComunaObj ||
      this.comunasYapp.find((c: any) => Number(c.com_id) === Number(this.selectedComunaId)) ||
      this.comunas.find((c: any) => Number(c.com_id) === Number(patient.use_address_com_id)) ||
      null;

    return {
      reg_id: regionSeleccionada?.reg_id ? Number(regionSeleccionada.reg_id) : null,
      reg_name: regionSeleccionada?.reg_name || null,
      com_id: comunaSeleccionada?.com_id ? Number(comunaSeleccionada.com_id) : null,
      com_name: comunaSeleccionada?.com_name || null,
      code_yapp: comunaSeleccionada?.code_yapp != null ? Number(comunaSeleccionada.code_yapp) : null
    };
  }

  private resolveCommune(): number {
    const ubicacionFinal = this.getUbicacionYappFinal();

    const raw =
      ubicacionFinal?.code_yapp ??
      ubicacionFinal?.com_id ??
      this.usuario?.commune ??
      this.usuario?.com_id ??
      13101;

    const n = Number(raw);

    return Number.isFinite(n) ? n : 13101;
  }

  onYappQueryChange(value: string): void {
    this.yappQuery = value;

    if (!this.mostrarBuscadorYapp()) {
      this.resetYappState();
      return;
    }

    const q = (value || '').trim();

    if (this.yappDebounceTimer) {
      clearTimeout(this.yappDebounceTimer);
      this.yappDebounceTimer = null;
    }

    if (q.length < 3) {
      this.yappResults = [];
      this.yappShowDropdown = false;
      this.yappLoading = false;
      return;
    }

    this.yappDebounceTimer = setTimeout(() => {
      this.buscarYapp(q);
    }, 300);
  }

  private async buscarYapp(q: string): Promise<void> {
    if (!q || q.trim().length < 3) {
      return;
    }

    const commune = this.yappCommune || this.resolveCommune();
    this.yappCommune = commune;

    const currentReq = ++this.yappReqId;

    this.yappLoading = true;
    this.yappShowDropdown = true;

    try {
      const body = {
        q: q.trim(),
        clinicalMedicaments: true,
        commercialProducts: true,
        commune: commune,
        groupCommercialProducts: false,
        patientCode: '053195',
        perPage: 15,
        largeScale: 'group',
        cenabast: false
      };

      const resp: any = await this._yappService.productSearch(body);

      if (currentReq !== this.yappReqId) {
        return;
      }

      const arr =
        Array.isArray(resp?.results) ? resp.results :
          Array.isArray(resp?.data) ? resp.data :
            Array.isArray(resp) ? resp :
              [];

      this.yappResults = arr || [];

    } catch (error) {
      if (currentReq !== this.yappReqId) {
        return;
      }

      console.error('Error buscando medicamentos YAPP:', error);
      this.yappResults = [];

    } finally {
      if (currentReq === this.yappReqId) {
        this.yappLoading = false;
      }
    }
  }

  selectYappItem(item: any): void {
    const title = this.getYappItemTitle(item);
    const subtitle = this.getYappItemSubtitle(item);

    if (!title) {
      return;
    }

    const ids = this.getYappItemIds(item);

    if (!ids.clinicalIds.length && !ids.commercialIds.length) {
      return;
    }

    const claveUnica = JSON.stringify({
      clinicalIds: ids.clinicalIds,
      commercialIds: ids.commercialIds
    });

    const yaExiste = this.yappSelectedItems.some((x: YappSelectedItem) => {
      const actual = JSON.stringify({
        clinicalIds: x.clinicalIds,
        commercialIds: x.commercialIds
      });

      return actual === claveUnica;
    });

    if (yaExiste) {
      this.yappQuery = '';
      this.yappResults = [];
      this.yappShowDropdown = false;
      return;
    }

    this.yappSelectedItems.push({
      clinicalIds: ids.clinicalIds,
      commercialIds: ids.commercialIds,
      title,
      subtitle,
      indication: ''
    });

    this.yappQuery = '';
    this.yappResults = [];
    this.yappShowDropdown = false;
  }

  removeYappItem(index: number): void {
    this.yappSelectedItems.splice(index, 1);
  }

  getYappItemTitle(item: any): string {
    return (
      item?.name ||
      item?.shortDescription ||
      item?.description ||
      item?.label ||
      item?.text ||
      'Medicamento'
    );
  }

  getYappItemSubtitle(item: any): string {
    return (
      item?.brand ||
      item?.laboratorio ||
      item?.laboratory ||
      item?.laboratoryName ||
      item?.presentation ||
      item?.extra ||
      ''
    );
  }

  private getYappItemIds(item: any): { clinicalIds: number[]; commercialIds: number[] } {
    const clinicalRaw = item?.ids?.clinical_medicament;
    const commercialRaw = item?.ids?.commercial_product;

    const clinicalIds = Array.isArray(clinicalRaw)
      ? clinicalRaw.map((id: any) => Number(id)).filter((id: number) => !!id)
      : clinicalRaw != null
        ? [Number(clinicalRaw)].filter((id: number) => !!id)
        : [];

    let commercialIds: number[] = [];

    if (clinicalIds.length > 0) {
      const firstDoseId = item?.commercialProductDoses?.[0]?.id;

      if (firstDoseId) {
        commercialIds = [Number(firstDoseId)];
      }
    } else {
      commercialIds = Array.isArray(commercialRaw)
        ? commercialRaw.map((id: any) => Number(id)).filter((id: number) => !!id)
        : commercialRaw != null
          ? [Number(commercialRaw)].filter((id: number) => !!id)
          : [];
    }

    return {
      clinicalIds,
      commercialIds
    };
  }

  private getYappSelectedIds(): { clinicos: number[]; comerciales: number[] } {
    const clinicos = this.yappSelectedItems
      .reduce((acc: number[], item: YappSelectedItem) => {
        return acc.concat(item.clinicalIds || []);
      }, [])
      .map((id: any) => Number(id))
      .filter((id: number) => !!id);

    const comerciales = this.yappSelectedItems
      .reduce((acc: number[], item: YappSelectedItem) => {
        return acc.concat(item.commercialIds || []);
      }, [])
      .map((id: any) => Number(id))
      .filter((id: number) => !!id);

    return {
      clinicos: Array.from(new Set(clinicos)),
      comerciales: Array.from(new Set(comerciales))
    };
  }

  private buildPrescriptionText(): string {
    const medicamentosYapp = this.yappSelectedItems.map((item: YappSelectedItem) => {
      const indicacion = (item.indication || '').trim();

      return indicacion
        ? `${item.title}\nIndicaciones: ${indicacion}`
        : `${item.title}`;
    });

    const textoLibre = (this.prescriptionForm.get('prescriptionText')?.value || '').trim();

    const bloques: string[] = [];

    if (medicamentosYapp.length) {
      bloques.push(medicamentosYapp.join('\n\n'));
    }

    if (textoLibre) {
      bloques.push(textoLibre);
    }

    return bloques.join('\n\n');
  }

  onYappIndicationChange(): void {
    // No se actualiza el textarea directamente para evitar duplicar texto.
    // El texto final se arma en buildPrescriptionText().
  }

  private resetYappState(): void {
    this.yappQuery = '';
    this.yappResults = [];
    this.yappLoading = false;
    this.yappShowDropdown = false;
    this.yappSelectedItems = [];
    this.selectedRegionId = null;
    this.selectedComunaId = null;
    this.selectedRegionObj = null;
    this.selectedComunaObj = null;
    this.regionesYapp = [];
    this.comunasYapp = [];
    this.yappCommune = 13101;
  }

  getTipoRecetaNombre(idReceta: any): string {
    const tipo = this.recetasFiltradas.find((r: any) => String(r.pre_typ_id) === String(idReceta));
    return tipo ? tipo.pre_typ_name : '—';
  }

  getPaisNombre(couId: any): string {
    const pais = this.paises.find((p: any) => String(p.cou_id) === String(couId));
    return pais ? pais.cou_name : '—';
  }

  getRegionNombre(regId: any): string {
    const region = this.regiones.find((r: any) => String(r.reg_id) === String(regId));
    return region ? region.reg_name : '—';
  }

  getComunaNombre(comId: any): string {
    const comuna = this.comunas.find((c: any) => String(c.com_id) === String(comId));
    return comuna ? comuna.com_name : '—';
  }

  buildDocumentoUrl(linkDoc: string): string {
    if (!linkDoc) {
      return '';
    }

    if (linkDoc.startsWith('http://') || linkDoc.startsWith('https://')) {
      return linkDoc;
    }

    const base = this.URL_DOCS.endsWith('/')
      ? this.URL_DOCS.slice(0, -1)
      : this.URL_DOCS;

    const path = linkDoc.startsWith('/')
      ? linkDoc
      : '/' + linkDoc;

    return base + path;
  }

  prepararDocumentoGenerado(response: any): void {
    const linkDoc = response?.linkDoc || '';

    if (!linkDoc) {
      this.documentoGeneradoUrl = '';
      this.safeDocumentoGeneradoUrl = null;
      console.warn('[RECETA TALONARIO DIGITAL] La respuesta no trae linkDoc.');
      return;
    }

    this.documentoGeneradoUrl = this.buildDocumentoUrl(linkDoc);
    const previewUrl = this.documentoGeneradoUrl + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH';

    this.safeDocumentoGeneradoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(previewUrl);

    // console.log('[RECETA TALONARIO DIGITAL] linkDoc recibido:', linkDoc);
    // console.log('[RECETA TALONARIO DIGITAL] URL_DOCS:', this.URL_DOCS);
    // console.log('[RECETA TALONARIO DIGITAL] URL documento completa:', this.documentoGeneradoUrl);
    // console.log('[RECETA TALONARIO DIGITAL] URL preview:', previewUrl);
  }

  private getAttIdFromResponse(response: any): any {
    return response?.att_id ||
      response?.attId ||
      response?.id_att ||
      response?.id_attachment ||
      response?.att?.att_id ||
      null;
  }

  descargarRecetaGenerada(): void {
    if (!this.documentoGeneradoUrl) {
      console.warn('[RECETA TALONARIO DIGITAL] No existe URL de documento.');
      return;
    }

    window.open(this.documentoGeneradoUrl, '_blank');
  }

  async enviarRecetaPorCorreo(): Promise<void> {
  this.mensajeReenvio = '';
  this.errorReenvio = '';

  const email = (this.resendEmailCtrl.value || '').toString().trim();

  if (!email) {
    this.errorReenvio = 'Debes ingresar un correo electrónico.';
    this.resendEmailCtrl.markAsTouched();

    Swal.fire({
      icon: 'warning',
      title: 'Correo requerido',
      text: this.errorReenvio,
      confirmButtonColor: '#2BABB7'
    });

    return;
  }

  if (this.resendEmailCtrl.invalid) {
    this.errorReenvio = 'El correo electrónico ingresado no es válido.';
    this.resendEmailCtrl.markAsTouched();

    Swal.fire({
      icon: 'warning',
      title: 'Correo inválido',
      text: this.errorReenvio,
      confirmButtonColor: '#2BABB7'
    });

    return;
  }

  const attId = this.attIdDocumentoGenerado || this.getAttIdFromResponse(this.respuestaCrearReceta);

  if (!attId) {
    this.errorReenvio = 'No existe att_id del documento generado. No es posible enviar la receta.';
    console.warn('[RECETA TALONARIO DIGITAL] No se encontró att_id en la respuesta:', this.respuestaCrearReceta);

    Swal.fire({
      icon: 'warning',
      title: 'Documento no disponible',
      text: this.errorReenvio,
      confirmButtonColor: '#2BABB7'
    });

    return;
  }

  const payloadBase = this.payloadRecetaGenerada
    ? JSON.parse(JSON.stringify(this.payloadRecetaGenerada))
    : this.buildPayloadRecetaTalonarioDigital();

  const payload = {
    datosPaciente: payloadBase.datosPaciente,
    att_id: attId,
    user_mail: email,
    typeDoc: 'receta'
  };

  this.loadingReenvio = true;

  Swal.fire({
    allowOutsideClick: false,
    allowEscapeKey: false,
    html: `
      <div style="margin: 40px 0;">
        <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
        <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #2BABB7;">
          Enviando documento
        </h1>
      </div>
    `,
    showConfirmButton: false
  });

  try {
    const response: any = await this._fichaMedicaServices.postEnviarDocumentoTalonarioDigital(payload);

    if (response && response.status === false) {
      this.errorReenvio = response.mensaje || 'No fue posible enviar la receta al correo indicado.';

      Swal.fire({
        icon: 'error',
        title: 'No fue posible enviar la receta',
        text: this.errorReenvio,
        confirmButtonColor: '#2BABB7'
      });

      return;
    }

    this.mensajeReenvio = 'La receta fue enviada correctamente al correo indicado.';
    this.resendEmailCtrl.reset('');

    Swal.fire({
      icon: 'success',
      title: 'Receta enviada',
      text: this.mensajeReenvio,
      confirmButtonColor: '#2BABB7'
    });

  } catch (error) {
    console.error('[RECETA TALONARIO DIGITAL] Error al enviar documento:', error);

    this.errorReenvio = 'No fue posible enviar la receta al correo indicado.';

    Swal.fire({
      icon: 'error',
      title: 'Error al enviar la receta',
      text: this.errorReenvio,
      confirmButtonColor: '#2BABB7'
    });

  } finally {
    this.loadingReenvio = false;
  }
}

  volverTalonario(): void {
    this.router.navigate(['/talonario']);
  }

  generarNuevaReceta(): void {
    this.currentStep = 0;

    this.steps = {
      searchPatient: true,
      prescriptionData: false,
      prescriptionFirma: false,
      prescriptionSummary: false
    };

    this.searchCtrl.setValue('', { emitEvent: false });

    this.resultados = [];
    this.loading = false;
    this.showDropdown = false;
    this.tooShort = false;
    this.searchRutInvalid = false;

    this.infoRut = {};
    this.isNewUser = false;
    this.step1Unlocked = false;

    this.clearPatientForm();

    this.prescriptionForm.reset({
      id_receta: '',
      prescriptionText: '',
      check_firma: false,
      signatureType: ''
    });

    this.yappQuery = '';
    this.yappResults = [];
    this.yappSelectedItems = [];
    this.yappShowDropdown = false;
    this.yappLoading = false;

    this.selectedRegionId = null;
    this.selectedComunaId = null;
    this.selectedRegionObj = null;
    this.selectedComunaObj = null;
    this.comunasYapp = [];

    this.resendEmailCtrl.reset('');

    this.loadingCrearReceta = false;
    this.respuestaCrearReceta = null;
    this.errorCrearReceta = '';
    this.payloadRecetaGenerada = null;

    this.documentoGeneradoUrl = '';
    this.safeDocumentoGeneradoUrl = null;
    this.attIdDocumentoGenerado = null;

    this.loadingReenvio = false;
    this.mensajeReenvio = '';
    this.errorReenvio = '';

    this.lockStep1Form();
  }

  private buildPayloadRecetaTalonarioDigital(): any {
    const paciente = this.patientForm.getRawValue();
    const receta = this.prescriptionForm.getRawValue();
    const textoFinal = this.buildPrescriptionText();
    const idsYapp = this.getYappSelectedIds();
    const isYapp = idsYapp.clinicos.length > 0 || idsYapp.comerciales.length > 0;
    const ubicacionYapp = this.getUbicacionYappFinal();

    if (this.mostrarBuscadorYapp() && isYapp) {
      if (!ubicacionYapp.reg_id || !ubicacionYapp.com_id || !ubicacionYapp.code_yapp) {
        throw new Error('Debes seleccionar región y comuna válidas para YAPP.');
      }
    }

    const payload = {
      datosPaciente: {
        use_rut: paciente.use_rut || '',
        use_name: paciente.use_name || '',
        use_paternal_surname: paciente.paterno || '',
        use_maternal_surname: paciente.materno || '',
        use_birthdate: paciente.nacimiento || '',
        use_cod_area: String(paciente.telefonoCodigo || this.selectedAreaCode?.cou_phone_code || '56'),
        use_movil_phone: String(paciente.telefono || ''),
        use_email: paciente.email || '',
        accion: paciente.use_id ? 'update' : 'insert',
        use_id: paciente.use_id || '',
        doc_id: this.usuario?.doc_id || null,
        ciudad: this.getRegionNombre(paciente.use_address_reg_id),
        direccion: paciente.use_address_street || '',
        nro: paciente.use_address_number || '',
        comuna: this.getComunaNombre(paciente.use_address_com_id)
      },
      datosReceta: {
        causal: '',
        pre_pre_typ_id: Number(receta.id_receta),
        pre_his_pre_id: '',
        pre_prescription: textoFinal,
        pre_indication: textoFinal,
        ids_yapp: {
          clinicos: idsYapp.clinicos,
          comerciales: idsYapp.comerciales
        },
        is_yapp: isYapp,
        is_fea: receta.signatureType === 'advanced',
        code_yapp: ubicacionYapp.code_yapp,
        reg_id: ubicacionYapp.reg_id || paciente.use_address_reg_id || null,
        reg_name: ubicacionYapp.reg_name || this.getRegionNombre(paciente.use_address_reg_id),
        com_id: ubicacionYapp.com_id || paciente.use_address_com_id || null,
        com_name: ubicacionYapp.com_name || this.getComunaNombre(paciente.use_address_com_id)
      }
    };

    return payload;
  }

  emitirReceta(): void {
    const textoFinal = this.buildPrescriptionText();

    if (!this.patientForm.valid || !this.prescriptionForm.get('id_receta')?.value || !textoFinal.trim() || !this.isStep3Valid()) {
      this.patientForm.markAllAsTouched();
      this.prescriptionForm.markAllAsTouched();
      return;
    }

    const idsYapp = this.getYappSelectedIds();
    const isYapp = idsYapp.clinicos.length > 0 || idsYapp.comerciales.length > 0;
    const ubicacionYapp = this.getUbicacionYappFinal();

    if (this.mostrarBuscadorYapp() && isYapp) {
      if (!ubicacionYapp.reg_id || !ubicacionYapp.com_id || !ubicacionYapp.code_yapp) {
        console.warn('Debes seleccionar región y comuna válidas para YAPP.');
        return;
      }
    }

    const payload = this.buildPayloadRecetaTalonarioDigital();

    // console.log('[RECETA TALONARIO DIGITAL] Payload actual:', payload);
    // console.log('[RECETA TALONARIO DIGITAL] Respuesta creación guardada:', this.respuestaCrearReceta);
  }

  allowOnlyLetters(event: KeyboardEvent): void {
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ'´\s]*$/;

    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  allowOnlyRutChars(event: KeyboardEvent): void {
  const key = event.key;

  if (
    key === 'Backspace' ||
    key === 'Delete' ||
    key === 'Tab' ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight' ||
    key === 'Home' ||
    key === 'End'
  ) {
    return;
  }

  if (!/^[0-9kK]$/.test(key)) {
    event.preventDefault();
  }
}

onRutPaste(event: ClipboardEvent): void {
  const pastedText = event.clipboardData?.getData('text') || '';

  if (!/^[0-9kK.-]+$/.test(pastedText)) {
    event.preventDefault();
  }
}

normalizeRutDigits(v: string): string {
  return (v || '')
    .toString()
    .replace(/\./g, '')
    .replace(/-/g, '')
    .toUpperCase()
    .replace(/[^0-9K]/g, '');
}

formatRutWithDash(v: string): string {
  const clean = this.normalizeRutDigits(v);

  if (clean.length <= 1) {
    return clean;
  }

  return clean.slice(0, -1) + '-' + clean.slice(-1);
}

  toDateInput(date: any): string {
    if (!date) {
      return '';
    }

    return String(date).substring(0, 10);
  }

  normArea(area: any): string {
    return String(area || '56');
  }

  normalizeList(resp: any): any[] {
    if (Array.isArray(resp)) {
      return resp;
    }

    if (Array.isArray(resp?.data)) {
      return resp.data;
    }

    if (Array.isArray(resp?.rows)) {
      return resp.rows;
    }

    if (Array.isArray(resp?.consulta)) {
      return resp.consulta;
    }

    return [];
  }

  getDefaultCountryId(): any {
    const chile = this.paises.find((p: any) =>
      String(p.cou_id) === '1' ||
      String(p.cou_name || '').toLowerCase().includes('chile')
    );

    return chile?.cou_id || this.paises[0]?.cou_id || 1;
  }

  @HostListener('document:click')
  clickOutside(): void {
    this.showDropdown = false;
    this.flagDropdownOpen = false;
    this.yappShowDropdown = false;
  }

}